import { render, staticRenderFns } from "./DefaultDescription.vue?vue&type=template&id=23accc86&scoped=true&lang=html"
import script from "./DefaultDescription.vue?vue&type=script&lang=js"
export * from "./DefaultDescription.vue?vue&type=script&lang=js"
import style0 from "./DefaultDescription.vue?vue&type=style&index=0&id=23accc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23accc86",
  null
  
)

export default component.exports